// src/pages/Cart/Cart.jsx
import React from 'react';
import CartPage from './Components/CartPage';

function Cart() {
  return (
    <div className="bg-background">
      <CartPage />
    </div>
  );
}

export default Cart;